module.exports = __webpack_public_path__ + "media/images/athletes/default-0da022fdc47eda10a12e594f4a027d2c.png";